import Form from "Clutch/Atoms/Form";
import { CalculateWheelOffsetEvent, CalculateSidewallHeight, CalculateWheelBackspacingEvent, CalculateFinalWheelSize } from "./logic";
import { useState } from "react";
import Typography from "Clutch/Atoms/Typography";
import Button from "Clutch/Molecules/Button";
import ContextualError from "../common/contextualError";
import FormGroup from "../common/formGroup";

const FinalWheelSizeByTire = () => {

    const [tireWidth, setTireWidth] = useState(0);
    const [tireAspectRatio, setTireAspectRatio] = useState(0);
    const [wheelDiameter, setWheelDiameter] = useState(0);
    const [tireSpacing, setTireSpacing] = useState(0);
    const [wheelWidth, setWheelWidth] = useState(0);
    const [wheelBackspacing, setWheelBackspacing] = useState(0);
    const [wheelOffset, setWheelOffset] = useState(0);
    const [result, setResult] = useState({
        isValid: false,
        errors: [],
        sidewallHeight: null,
        wheelOffset: null,
        wheelBackspacing: null,
        finalWheelSize: null,
    });

    const CalculateInternal = (e) => {
        e.preventDefault()
        if (wheelBackspacing > 0)
        {
            const r = CalculateFinalWheelSize({ wheelDiameter, wheelWidth, wheelBackspacing, wheelOffset})
            setResult(r);
        }
        else if (wheelWidth > 0 && wheelDiameter > 0)
        {
            console.log("In backspace");
            const r = CalculateWheelBackspacingEvent({ tireSpacing, tireWidth, wheelWidth, isMetric: true });
            setWheelBackspacing(r.wheelBackspacing);
            setResult(r);
        }
        else if (tireSpacing > 0 && result.sidewallHeight > 0 && tireWidth > 0) {
            console.log("In wheel offset")
            const r = CalculateWheelOffsetEvent({ tireSpacing, tireWidth, isMetric: true });
            setWheelOffset(r.wheelOffset);
            setResult(r);
        }
        else {
            console.log("in sidewall");
            const r = CalculateSidewallHeight({ tireWidth, tireAspectRatio });
            setResult(r)
        }
    }

    // const shouldTireSpacingBeDisabled = (wheelOffset === 0 || wheelOffset === '' || desiredTireWidth === 0 || desiredTireWidth === '');
    // const shouldFinalTireSizeButtonBeDisabled = (wheelDiameter === 0 || wheelDiameter === '' || sidewallHeight === 0 || sidewallHeight === '')

    const tireWidthError = result.errors.find(x => x.id == 'tireWidth');
    const tireAspectRatioError = result.errors.find(x => x.id == 'tireAspectRatio');
    const sidewallHeightError = result.errors.find(x => x.id == 'sidewallHeight');
    const tireSpacingError = result.errors.find(x => x.id == 'tireSpacing');
    const wheelOffsetError = result.errors.find(x => x.id == 'wheelOffset');
    const wheelDiameterError = result.errors.find(x => x.id == 'wheelDiameter');
    const wheelWidthError = result.errors.find(x => x.id == 'wheelWidth');
    const wheelBackspacingError = result.errors.find(x => x.id == 'wheelBackspacing');

    return <Form onSubmit={CalculateInternal}>
        <FormGroup>
            <Form.Textbox
                fill
                id={'tireWidth'}
                label={`Tire Width (millimeters)`}
                intent={tireWidthError ? 'negative' : null}
                value={tireWidth}
                onChange={(e) => { setTireWidth(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={tireWidthError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'tireAspectRatio'}
                label={`Tire Aspect Ratio`}
                intent={tireAspectRatioError ? 'negative' : null}
                value={tireAspectRatio}
                onChange={(e) => { setTireAspectRatio(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={tireAspectRatioError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'wheelDiameter'}
                label={`Wheel Diameter (inches)`}
                intent={wheelDiameterError ? 'negative' : null}
                value={wheelDiameter}
                onChange={(e) => { setWheelDiameter(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={wheelDiameterError} />
        </FormGroup>

        <FormGroup>
            <Button intent={'action'} size={'small'} event={{}} text={"Calculate Sidewall Height"}></Button>
        </FormGroup>
        < br />
        <FormGroup>
            <Form.Textbox
                fill
                id={'sidewallHeight'}
                label={`Sidewall Height (millimeters)`}
                intent={sidewallHeightError ? 'negative' : null}
                value={result.sidewallHeight}
            />
            <ContextualError error={sidewallHeightError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'tireSpacing'}
                label={`Tire Spacing (millimeters)`}
                intent={tireSpacingError ? 'negative' : null}
                value={tireSpacing}
                onChange={(e) => { setTireSpacing(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={tireSpacingError} />
        </FormGroup>
        <FormGroup>
            <Button intent={'action'} size={'small'} event={{}} text={"Calculate Wheel Offset"}></Button>
        </FormGroup>
        < br />
        <FormGroup>
            <Form.Textbox
                fill
                id={'wheelOffset'}
                label={`Wheel Offset (millimeters)`}
                intent={wheelOffsetError ? 'negative' : null}
                value={result.wheelOffset}
            />
            <ContextualError error={wheelOffsetError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'wheelWidth'}
                label={`Wheel Width (inches)`}
                intent={wheelWidthError ? 'negative' : null}
                value={wheelWidth}
                onChange={(e) => { setWheelWidth(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={wheelWidthError} />
        </FormGroup>
        <FormGroup>
            <Button intent={'action'} size={'small'} event={{}} text={"Calculate Wheel Backspacing"}></Button>
        </FormGroup>
        < br />
        <FormGroup>
            <Form.Textbox
                fill
                id={'wheelBackspacing'}
                label={`Wheel Backspacing (inches)`}
                intent={wheelBackspacingError ? 'negative' : null}
                value={result.wheelBackspacing}
            />
            <ContextualError error={wheelBackspacingError} />
        </FormGroup>
        <FormGroup>
            <Button intent={'action'} size={'small'} event={{}} text={"Calculate Final Wheel Size"}></Button>
        </FormGroup>
        <FormGroup>
            {result.isValid ? <Typography as={'span'} size={1.25} font={'bold'}>{result.finalWheelSize}</Typography> : false}
        </FormGroup>
    </Form>
}

export default FinalWheelSizeByTire